import React from 'react';
import { Typography } from '@mui/material';
import LegalPageLayout from '../components/LegalPageLayout';

const PoliticaPrivacidade: React.FC = () => {
  return (
    <LegalPageLayout
      title="Política de Privacidade"
      updatedAt="28 de setembro de 2026"
      seoTitle="Política de Privacidade | MedPrime Benefícios"
      seoDescription="Política de Privacidade da MedPrime Benefícios e informações sobre o tratamento de dados pessoais."
      canonicalPath="/privacidade"
    >
      <Typography component="p">
        A <strong>MedPrime Benefícios</strong> respeita a privacidade dos visitantes e leads deste
        site e realiza o tratamento de dados pessoais de acordo com a legislação brasileira
        aplicável, especialmente a Lei Geral de Proteção de Dados Pessoais (Lei nº 13.709/2018 —
        LGPD).
      </Typography>
      <Typography component="p">
        <strong>MedPrime Benefícios</strong> é a marca comercial utilizada por{' '}
        <strong>VITOR DE OLIVEIRA JUNIOR INFORMATICA</strong> (CNPJ 32.256.713/0001-07), empresa
        responsável pelo tratamento dos dados coletados por meio deste site, para suas atividades
        de apresentação e atendimento comercial relacionadas a planos de saúde.
      </Typography>

      <Typography component="h2">1. Dados coletados</Typography>
      <Typography component="p">
        Esta landing page pode coletar os seguintes dados, fornecidos voluntariamente pelo
        visitante através do formulário de cotação ou dos canais de contato disponibilizados:
      </Typography>
      <ul>
        <li>Nome completo;</li>
        <li>WhatsApp;</li>
        <li>E-mail;</li>
        <li>Profissão;</li>
        <li>Informação sobre possuir ou não CNPJ;</li>
        <li>Quantidade de pessoas a serem incluídas no plano;</li>
        <li>Cidade e estado;</li>
        <li>Informações fornecidas voluntariamente durante o atendimento, inclusive pelo WhatsApp.</li>
      </ul>
      <Typography component="p">
        Adicionalmente, ao preencher o formulário, o site coleta de forma automática algumas
        informações técnicas que ajudam a identificar a origem e o contexto do contato, como
        endereço IP e localização aproximada, informações do navegador e do dispositivo utilizado
        (como sistema operacional e resolução de tela) e parâmetros de origem da visita (por
        exemplo, parâmetros de campanha "utm").
      </Typography>

      <Typography component="h2">2. Finalidade do tratamento</Typography>
      <Typography component="p">Os dados coletados podem ser utilizados para:</Typography>
      <ul>
        <li>Responder solicitações enviadas pelo formulário ou pelos canais de contato;</li>
        <li>Entrar em contato com o interessado;</li>
        <li>Elaborar propostas comerciais;</li>
        <li>Apresentar opções de planos de saúde compatíveis com o perfil informado;</li>
        <li>Realizar atendimento comercial;</li>
        <li>Prestar suporte ao interessado;</li>
        <li>Melhorar os serviços e a experiência oferecidos neste site;</li>
        <li>Manter registros necessários à operação e ao atendimento comercial.</li>
      </ul>

      <Typography component="h2">3. Atendimento por WhatsApp</Typography>
      <Typography component="p">
        Este site disponibiliza o WhatsApp como canal de contato e atendimento. Quando o visitante
        opta por entrar em contato pelo WhatsApp, o tratamento das mensagens trocadas ocorre no
        próprio aplicativo, sujeito também aos termos e políticas de privacidade do WhatsApp/Meta.
      </Typography>
      <Typography component="p">
        A MedPrime Benefícios não controla a infraestrutura do WhatsApp e utiliza esse canal
        exclusivamente como meio de comunicação e atendimento comercial. Não há qualquer parceria
        comercial formal, certificação ou aprovação da Meta associada à MedPrime Benefícios.
      </Typography>

      <Typography component="h2">4. Dados sensíveis</Typography>
      <Typography component="p">
        Por lidar com o segmento de planos de saúde, a MedPrime Benefícios adota especial cuidado
        com dados sensíveis. O formulário deste site não solicita dados de saúde no primeiro
        contato, tais como diagnóstico, doença, histórico médico, exames, medicamentos ou
        prontuários. As informações coletadas no primeiro contato são de natureza comercial
        (identificação, contato e perfil de contratação).
      </Typography>
      <Typography component="p">
        Caso o visitante opte por compartilhar voluntariamente informações adicionais durante o
        atendimento (por exemplo, via WhatsApp), essas informações serão tratadas com o mesmo
        cuidado e apenas para a finalidade de viabilizar o atendimento e a proposta solicitada.
      </Typography>

      <Typography component="h2">5. Compartilhamento de dados</Typography>
      <Typography component="p">
        A MedPrime Benefícios não vende dados pessoais. Os dados coletados podem ser tratados por
        fornecedores necessários à operação deste site, à comunicação e ao atendimento comercial,
        entre eles:
      </Typography>
      <ul>
        <li>Serviços de hospedagem e infraestrutura utilizados para publicar o site e a API;</li>
        <li>Serviço de geolocalização por IP, utilizado para identificar a região aproximada do visitante que preenche o formulário;</li>
        <li>WhatsApp, quando o visitante opta por esse canal de atendimento.</li>
      </ul>
      <Typography component="p">
        Os dados podem ainda ser compartilhados quando exigido por obrigação legal ou determinação
        de autoridade competente.
      </Typography>

      <Typography component="h2">6. Segurança da informação</Typography>
      <Typography component="p">
        Adotamos medidas técnicas e organizacionais razoáveis para proteger os dados pessoais
        contra acesso não autorizado, perda, alteração, divulgação indevida ou destruição. Nenhum
        sistema é totalmente livre de riscos, e trabalhamos para manter práticas de segurança
        adequadas ao volume e à natureza dos dados tratados.
      </Typography>

      <Typography component="h2">7. Direitos do titular dos dados</Typography>
      <Typography component="p">
        Nos termos da LGPD, o titular dos dados pode solicitar, a qualquer momento:
      </Typography>
      <ul>
        <li>Confirmação da existência de tratamento de dados;</li>
        <li>Acesso aos dados pessoais tratados;</li>
        <li>Correção de dados incompletos, inexatos ou desatualizados;</li>
        <li>Eliminação dos dados pessoais tratados, quando aplicável;</li>
        <li>Informações sobre o compartilhamento dos dados;</li>
        <li>Demais direitos previstos na legislação aplicável.</li>
      </ul>
      <Typography component="p">
        Para exercer esses direitos ou esclarecer dúvidas sobre esta Política, entre em contato
        pelo e-mail{' '}
        <strong>contato@medprimebeneficios.com.br</strong>.
      </Typography>

      <Typography component="h2">8. Empresa responsável</Typography>
      <Typography component="p">
        <strong>VITOR DE OLIVEIRA JUNIOR INFORMATICA</strong>
        <br />
        CNPJ: 32.256.713/0001-07
        <br />
        Endereço: Avenida do Taboão, nº 3207, Bloco 2, Apto 1007, Bairro Taboão, São Bernardo do
        Campo — SP, CEP 09656-000
      </Typography>

      <Typography component="h2">9. Alterações desta Política</Typography>
      <Typography component="p">
        Esta Política de Privacidade pode ser atualizada periodicamente para refletir melhorias no
        site ou mudanças na legislação aplicável. A data da última atualização está indicada no
        topo desta página.
      </Typography>
    </LegalPageLayout>
  );
};

export default PoliticaPrivacidade;
